export { default } from "./TeamInfo";
